"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveLargeText = exports.applyLargeText = exports.isLargeText = void 0;
const constants_1 = require("@/constants");
const storage_1 = require("@/utils/storage");
const LARGE_TEXT_CLASS = 'large-text';
function isLargeText() {
    return (0, storage_1.readStorage)(constants_1.LARGE_TEXT_STORAGE_KEY) === 'true';
}
exports.isLargeText = isLargeText;
function applyLargeText(enabled = isLargeText()) {
    document.documentElement.classList.toggle(LARGE_TEXT_CLASS, enabled);
    return enabled;
}
exports.applyLargeText = applyLargeText;
function saveLargeText(enabled) {
    (0, storage_1.writeStorage)(constants_1.LARGE_TEXT_STORAGE_KEY, String(enabled));
    return applyLargeText(enabled);
}
exports.saveLargeText = saveLargeText;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGFyZ2UtdGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImxhcmdlLXRleHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMkNBQW9EO0FBQ3BELDZDQUEyRDtBQUUzRCxNQUFNLGdCQUFnQixHQUFHLFlBQVksQ0FBQTtBQUVyQyxTQUFnQixXQUFXO0lBQ3pCLE9BQU8sSUFBQSxxQkFBVyxFQUFDLGtDQUFzQixDQUFDLEtBQUssTUFBTSxDQUFBO0FBQ3ZELENBQUM7QUFGRCxrQ0FFQztBQUVELFNBQWdCLGNBQWMsQ0FBQyxPQUFPLEdBQUcsV0FBVyxFQUFFO0lBQ3BELFFBQVEsQ0FBQyxlQUFlLENBQUMsU0FBUyxDQUFDLE1BQU0sQ0FBQyxnQkFBZ0IsRUFBRSxPQUFPLENBQUMsQ0FBQTtJQUNwRSxPQUFPLE9BQU8sQ0FBQTtBQUNoQixDQUFDO0FBSEQsd0NBR0M7QUFFRCxTQUFnQixhQUFhLENBQUMsT0FBZ0I7SUFDNUMsSUFBQSxzQkFBWSxFQUFDLGtDQUFzQixFQUFFLE1BQU0sQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFBO0lBQ3JELE9BQU8sY0FBYyxDQUFDLE9BQU8sQ0FBQyxDQUFBO0FBQ2hDLENBQUM7QUFIRCxzQ0FHQyJ9